import React from 'react';
import { Chats } from '@modules/chat/components/sidebar';
import { Container } from '@common/components/container';
import { useChatStore, withChatStore } from '@modules/chat/store/chatStore';
import NoConversationSelected from '@modules/chat/components/no-conversation-selected';

import '../../styles.scss';
import Conversation from '../conversation/conversation';

interface ChatProps {
  basePath: string;
}

const Chat = (props: ChatProps) => {
  const { basePath } = props;

  const {
    conversations,
    currentConversation,
    usersStatus,
    messages,
    setMessages,
    handleNewMessage,
    handleOpenProfile,
    handleToggleNotifications,
    handleToggleArchive,
    handleRemoveConversation,
    handleEditGroupAdmin,
    handleEditParticipants,
    handleLeave,
    handleUpdateConversation,
    handleUpdateLastMessage,
    setNewConversationModalVisible,
    handleConversationPinOrUnpin,
    handleConversationMarkAsReadOrUnread,
    handleConversationFavouriteOrUnfavourite,
    handleConversationMuteOrUnmute,
  } = useChatStore();

  return (
    <>
      <Chats basePath={basePath} />
      <Container name="Chat">
        <div
          className="
          tw-flex tw-flex-col tw-w-full tw-h-full
          tw-bg-[url('/static/images/chat/chat-bg.jpg')] tw-bg-contain"
        >
          <Container.Column>
            {currentConversation ? (
              <Conversation
                conversation={currentConversation}
                empty={conversations?.length === 0}
                messages={messages}
                usersStatus={usersStatus}
                // @ts-expect-error
                setMessages={setMessages}
                onNewMessage={handleNewMessage}
                onOpenProfile={handleOpenProfile}
                onToggleNotifications={handleToggleNotifications}
                onToggleArchive={handleToggleArchive}
                onRemoveConversation={handleRemoveConversation}
                onEditGroupAdmin={handleEditGroupAdmin}
                onEditParticipants={handleEditParticipants}
                onLeave={handleLeave}
                onUpdateConversation={handleUpdateConversation}
                onUpdateLastMessage={handleUpdateLastMessage}
                setNewConversationModalVisible={setNewConversationModalVisible}
                onConversationPinOrUnpin={handleConversationPinOrUnpin}
                onConversationMarkAsReadOrUnread={handleConversationMarkAsReadOrUnread}
                onConversationFavouriteOrUnfavourite={handleConversationFavouriteOrUnfavourite}
                onConversationMuteOrUnmute={handleConversationMuteOrUnmute}
                basePath={basePath}
              />
            ) : (
              <NoConversationSelected />
            )}
          </Container.Column>
        </div>
      </Container>
    </>
  );
};

export default withChatStore(Chat);
